import {Collection} from "./collection";
import {BBModel} from "../bb_model";

class ClientCollection extends Collection {

    constructor(resource, set) {
        super(resource, set);
        this.promise = new Promise((resolve, reject) => {
            resource.$get('clients').then((clients) => {
                this.url = resource.$link('self').href;
                this.items = (clients).map(client => new BBModel.Admin.Client(client));
                this.items.forEach(client => set.updateItem(client));
                this.total_entries = resource.total_entries;
                this.listenForPush(set);
                resolve(this);
            }, reject);
        });
    }

    addClient(newClient) {
        this.items.push(newClient);
        this.callListeners();
    }

    updateClient(newClient) {
        const client = this.find(newClient.id);
        if (client && client.deleted) {
            const index = this.findIndex(newClient.id);
            if (index > -1) this.items.splice(index, 1);
            this.callListeners();
        } else if (client) {
            this.callListeners();
        } else {
            this.addClient(newClient);
        }
    }

    handlePush(push) {
        if (push.action == 'destroy') {
            this.pushDelete(push);
        } else {
            const newClient = push.object;
            if (newClient && newClient.deleted) {
                const index = this.findIndex(newClient.id);
                if (index > -1) this.items.splice(index, 1);
                this.callListeners();
            } else {
                if (this.start_date && this.end_date) {
                    switch (push.action) {
                        case 'create':
                            this.addClient(newClient);
                            break;
                        case 'update':
                            this.updateClient(newClient);
                            break;
                    }
                } else {
                    this.$refetch(push.set).then(() => {
                        this.callListeners();
                    });
                }
            }
        }
    }

    static $query(set, company, params) {
        params = params || {};
        return super.$query(ClientCollection, set, company, params);
    }

}

ClientCollection.group = 'client';

export {
    ClientCollection
}